import {property} from '@wonderlandengine/api/decorators.js';
import {SoundManagerInstance, Sounds} from '../../managers/soundmanager.js';
import {ActionBase} from './action-base.js';

/**
 * General and reusable audio action.
 * This action is used to play audio when the trigger is activated.
 */
export class ActionAudio extends ActionBase {
    static TypeName = 'action-audio';

    /**
     * The name of the sound to play.
     * Must be a sound that is loaded in the SoundManager.
     */
    @property.string()
    soundName = '';

    /**
     * Play the audio only once. Even if the trigger is activated multiple times.
     */
    @property.bool(false)
    playOnce = false;

    /**
     * If true, the audio will loop.
     */
    @property.bool(false)
    loop = false;

    /**
     * If true, the audio will stop playing when triggered.
     */
    @property.bool(false)
    stop = false;

    /**
     * The volume of the audio.
     */
    @property.float(1.0)
    volume = 1.0;

    private hasPlayed = false;

    OnTrigger() {
        if (this.playOnce && this.hasPlayed) {
            return;
        }

        SoundManagerInstance.playSound(this.soundName as Sounds, this.loop, this.volume);
        this.hasPlayed = true;
    }
}
